import axios from 'axios'
import { Service } from 'axios-middleware'
import { getCookie } from '../shared/utils/pipes'

export const service = new Service(axios)

service.register({
  onRequest(config) {
    let token = null
    let ip = null
    try {
      token = getCookie('token')
      const existingToken = config.headers.Authorization
      if (token && !existingToken) {
        config.headers.Authorization = `Bearer ${token || ''}`
      }
    } catch (e) {
      token = null
    }

    try {
      ip = sessionStorage.getItem('X-Client-IP')
      const existingIp = config.headers['X-Client-IP']
      if (ip && !existingIp) {
        config.headers['X-Client-IP'] = ip || ''
      }
    } catch (e) {
      ip = null
    }

    return config
  },
  onSync(promise) {
    return promise
  },
  onResponse(response) {
    return response
  },
  onerror(error) {
    return Promise.reject(error)
  },
})
